import React, { useEffect, useState } from "react";
import "./App.css";
import "./styles/patriotic.css";
import "./pages/HomePage.funnel.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LeadConnectorWidget from "./components/LeadConnectorWidget";
import ScrollToTop from "./components/ScrollToTop";
import SkoolCommunityPopup from "./components/SkoolCommunityPopup";
import SignupPopup from "./components/SignupPopup";
import JuneCodeMascot from "./components/JuneCodeMascot";
import Fireworks from "./components/Fireworks";
import PromoCodeAppender from "./components/PromoCodeAppender";
import { PatrioticThemeProvider, usePatrioticTheme } from "./components/PatrioticTheme";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import CreditRepairPage from "./pages/CreditRepairPage";
import WealthRebuildPage from "./pages/WealthRebuildPage";
import StudentLoanRemovalPage from "./pages/StudentLoanRemovalPage";
import BusinessFormationPage from "./pages/BusinessFormationPage";
import CompliancePage from "./pages/CompliancePage";
import ContactPage from "./pages/ContactPage";
import AdminDashboard from "./pages/AdminDashboard";
import EliteTransformationPage from "./pages/EliteTransformationPage";
import PrimaryTradelinesPage from "./pages/PrimaryTradelinesPage";
import AUTradelinesPage from "./pages/AUTradelinesPage";
import BusinessTradelinesPage from "./pages/BusinessTradelinesPage";
import ShelfCorporationsPage from "./pages/ShelfCorporationsPage";
import GuidesPage from "./pages/GuidesPage";
import LimitedTimeOfferPage from "./pages/LimitedTimeOfferPage";
import BooksPage from "./pages/BooksPage";
import StarterTradelinePage from "./pages/StarterTradelinePage";
import EliteTradelinePackagePage from "./pages/EliteTradelinePackagePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import AIClonePage from "./pages/AIClonePage";
import MillionDollarSoftwarePage from "./pages/MillionDollarSoftwarePage";
import MentorshipPage from "./pages/MentorshipPage";
import FundingQualifierPage from "./pages/FundingQualifierPage";
import PerfectCreditMonitoringPage from "./pages/PerfectCreditMonitoringPage";
import AiAutopilotBasePackagePage from "./pages/AiAutopilotBasePackagePage";
import AutopilotFunnelPage from "./pages/autopilot/AutopilotFunnelPage";
import LinksPage from "./pages/LinksPage";
import ShareholderRewardsPage from "./pages/ShareholderRewardsPage";
import MerchPage from "./pages/MerchPage";
import VegasMastermindPage from "./pages/VegasMastermindPage";
import ChatGptDisputePromptPage from "./pages/ChatGptDisputePromptPage";
import InsuranceRecoveryPage from "./pages/InsuranceRecoveryPage";
import WelcomePage from "./pages/WelcomePage";
import VipDayPage from "./pages/VipDayPage";
import GWagonBackground from "./components/GWagonBackground";

// Internal layout that needs theme context access (e.g., gating fireworks)
const AppShell = () => {
  const { enabled } = usePatrioticTheme();
  const location = useLocation();
  // Routes that opt out of the patriotic overlay (fireworks / mascot / banner)
  // so their own aesthetic reads cleanly. Vegas Mastermind = luxury black/gold.
  const luxuryRoute = location.pathname.startsWith('/vegas-mastermind');
  return (
    <>
      <ScrollToTop />
      <GWagonBackground />
      {enabled && !luxuryRoute && <Fireworks />}
      <Header />
      <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/credit-repair" element={<CreditRepairPage />} />
          <Route path="/wealth-rebuild" element={<WealthRebuildPage />} />
          <Route path="/elite-transformation" element={<EliteTransformationPage />} />
          <Route path="/primary-tradelines" element={<PrimaryTradelinesPage />} />
          <Route path="/au-tradelines" element={<AUTradelinesPage />} />
          <Route path="/business-tradelines" element={<BusinessTradelinesPage />} />
          <Route path="/shelf-corporations" element={<ShelfCorporationsPage />} />
          <Route path="/guides" element={<GuidesPage />} />
          <Route path="/limited-offer" element={<LimitedTimeOfferPage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/starter-tradeline" element={<StarterTradelinePage />} />
          <Route path="/student-loan-removal" element={<StudentLoanRemovalPage />} />
          <Route path="/credit-repair-only" element={<Navigate to="/credit-repair" replace />} />
          <Route path="/elite-tradeline-package" element={<EliteTradelinePackagePage />} />
          <Route path="/ai-clone" element={<AIClonePage />} />
          <Route path="/mentorship" element={<MentorshipPage />} />
          <Route path="/million-dollar-software" element={<MillionDollarSoftwarePage />} />
          <Route path="/funding-qualifier" element={<FundingQualifierPage />} />
          <Route path="/perfect-credit-monitoring" element={<PerfectCreditMonitoringPage />} />
          <Route path="/ai-autopilot-base-package" element={<AiAutopilotBasePackagePage />} />
          <Route path="/autopilot" element={<AutopilotFunnelPage />} />
          <Route path="/links" element={<LinksPage />} />
          <Route path="/shareholder-rewards" element={<ShareholderRewardsPage />} />
          <Route path="/merch" element={<MerchPage />} />
          <Route path="/vegas-mastermind" element={<VegasMastermindPage />} />
          <Route path="/chatgpt-dispute-prompt" element={<ChatGptDisputePromptPage />} />
          <Route path="/insurance-recovery" element={<InsuranceRecoveryPage />} />
          <Route path="/insurance" element={<InsuranceRecoveryPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/vip-day" element={<VipDayPage />} />
          <Route path="/diminished-value" element={<Navigate to="/insurance" replace />} />
          <Route path="/snapchat-dispute-prompt" element={<Navigate to="/chatgpt-dispute-prompt" replace />} />
          <Route path="/dispute-prompt" element={<Navigate to="/chatgpt-dispute-prompt" replace />} />
          <Route path="/business-formation" element={<BusinessFormationPage />} />
          <Route path="/compliance" element={<CompliancePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Footer />
        <LeadConnectorWidget />
        <SkoolCommunityPopup />
        <SignupPopup />
        {!luxuryRoute && location.pathname !== '/' && <JuneCodeMascot />}
        <PromoCodeAppender />
    </>
  );
};

function App() {
  const [isValentinesDay, setIsValentinesDay] = useState(false);

  useEffect(() => {
    const checkValentinesDay = () => {
      const now = new Date();
      const month = now.getMonth();
      const day = now.getDate();
      setIsValentinesDay(month === 1 && day === 14);
    };
    checkValentinesDay();
    const interval = setInterval(checkValentinesDay, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`App ${isValentinesDay ? 'valentines-theme' : ''}`}>
      <BrowserRouter>
        <PatrioticThemeProvider>
          <AppShell />
        </PatrioticThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
